module.exports = __webpack_public_path__ + "static/media/uninformedPayment.0cc9ec8a.png";